import React from 'react';
import { ETSY_SHOP_URL, CONTACT_EMAIL } from '../../lib/constants';

const CTA: React.FC = () => (
  <section className="max-w-7xl mx-auto px-6 mb-16">
    <div className="bg-green-600 text-white rounded-2xl p-12 md:p-16 text-center">
      <h2 className="text-3xl md:text-4xl font-bold mb-3">
        Ready to travel more securely?
      </h2>
      <p className="text-lg opacity-90 mb-8">
        Handmade in the UK. Shipped worldwide from our Etsy shop.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href={ETSY_SHOP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-green-700 px-9 py-4 rounded-lg font-semibold text-lg hover:bg-green-50 transition-colors"
        >
          Shop on Etsy
        </a>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="inline-block border-2 border-white/50 text-white px-8 py-3.5 rounded-lg font-semibold text-lg hover:bg-white/10 transition-colors"
        >
          Get in Touch
        </a>
      </div>
    </div>
  </section>
);

export default CTA;
